import { render, staticRenderFns } from "./OptimizedpaintlistviewPage.vue?vue&type=template&id=7104fba8"
import script from "./OptimizedpaintlistviewPage.vue?vue&type=script&lang=js"
export * from "./OptimizedpaintlistviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports